module.exports = __webpack_public_path__ + "assets-cabinet/img/it.6956b63d.svg";